import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Text, { TextColor } from '@/components/view/atoms/text/Text'
import InternalLink from '@/components/view/utils/link/InternalLink'
import {
  NavigationColor,
  navColorClass,
  navColorSelectedClass
} from '@/components/view/utils/nav/navigation'

interface Props extends ChildProps {
  link?: string
  selected?: boolean
  viewing?: boolean
  color?: NavigationColor
  onClick?: () => void
  grandChild?: boolean
}

const NavigationChildRow = ({
  children,
  link,
  selected = false,
  viewing = false,
  color = NavigationColor.ORANGE,
  onClick,
  grandChild = false
}: Props) => {
  const className = clsx(
    'relative outline-default flex items-center gap-x-2 focus-visible:outline-offset-0 transition duration-300 ease-in-out',
    grandChild ? 'pl-10 pr-1 py-1.5' : 'pl-6 pr-1 py-1.5',
    'rounded-r-lg',
    viewing && 'bg-surface',
    (link || onClick) && `hover:bg-fill-transparent-hover active:bg-fill-transparent-active`,
    selected && navColorSelectedClass(color),
    (viewing || selected) && 'mr-6'
  )

  const Content = () => (
    <>
      {viewing && (
        <span className={clsx('absolute left-0.75 block h-5 w-1', navColorClass(color))} />
      )}
      <Text
        size={12}
        color={selected ? TextColor.ON_BG_FILL : TextColor.PRIMARY}
        lineHeight={120}
        weight={viewing ? 'bold' : 'normal'}
      >
        {children}
      </Text>
    </>
  )

  return link ? (
    <InternalLink link={link} className={className} onClick={onClick}>
      <Content />
    </InternalLink>
  ) : onClick ? (
    <button className={className} onClick={onClick}>
      <Content />
    </button>
  ) : (
    <span className={className}>
      <Content />
    </span>
  )
}

export default NavigationChildRow
